import declensionByNum from 'src/utils/declensionByNum'

const CLINIC_WORD_FORMS = ['клинику', 'клиники', 'клиник'] as const

export function formatAnalysesLpuCountLabel(count: number): string {
  return `Показать ${count.toLocaleString('ru-RU')} ${declensionByNum(count, [...CLINIC_WORD_FORMS])}`
}
